// extracted by mini-css-extract-plugin
export default {"titleBottomBox":"styles_titleBottomBox__9saFG","title":"styles_title__l3itc","subtitle":"styles_subtitle__gbYpf"};